<template>
  <section id="in-evidenza" class="container px-4 my-4">
    <h3 class="mb-4 text-primary">Pronunce</h3>
    <div class="row">
      <div v-if="filtersSet()">
        <Filters />
      </div>
    </div>
    <ul class="nav nav-tabs auto" id="myTab" role="tablist">
      <li class="nav-item">
        <a
          class="nav-link active"
          id="tab-sentenze-tab"
          data-toggle="tab"
          href="#tab-sentenze"
          role="tab"
          aria-controls="tab-sentenze"
          aria-selected="true">
          Sentenze
          <span class="badge sentenze-bg badge-total-pronunce">{{documentsList.totalSentenze}}</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="tab-ordinanze-tab"
          data-toggle="tab"
          href="#tab-ordinanze"
          role="tab"
          aria-controls="tab-ordinanze"
          aria-selected="false">
          Ordinanze
          <span class="badge ordinanze-bg badge-total-pronunce">{{documentsList.totalOrdinanze}}</span>
        </a>
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <div
        class="tab-pane p-4 fade show active"
        id="tab-sentenze"
        role="tabpanel"
        aria-labelledby="tab-sentenze-tab">
        <table
          class="table table-striped">
          <thead>
            <tr>
              <th scope="col" sortable>Numero/Anno</th>
              <th scope="col" class="d-none d-sm-table-cell">ECLI</th>
              <th scope="col" class="d-none d-sm-table-cell">Presidente</th>
              <th scope="col" >Relatore</th>
              <th scope="col" class="d-none d-sm-table-cell">Azioni</th>
            </tr>
          </thead>
         <tbody v-if="noResults.sentenze">
            <th
                scope="row"
                colspan="5">
                <h6>Nessun Risultato per la tua ricerca! <a href="#" data-toggle="modal" data-target="#modalsearch"> Prova a corregerla!</a></h6>
              </th>
          </tbody>
          <tbody v-if="documentsList.sentenze.length >= 1">
            <tr v-for="(pronuncia, $index) in documentsList.sentenze"
                :key="$index"
                :set="p=pronuncia.pronunciaInfo">
              <th scope="row">
                <router-link
                  class="spacing nav-link"
                  :to="{
                    path: `pronuncia/sentenza/${p.year}/${p.number}`,
                    // query: {docUri: p.docUri},
                  }">
                {{p.number}}/{{p.year}}
                </router-link>
              </th>
              <td class="d-none d-sm-table-cell">
                <strong class="sentenze-text">
                  {{p.ecli}}
                </strong>
              </td>
              <td class="d-none d-sm-table-cell">{{p.presidente}}</td>
              <td>{{p.relatore}}</td>
              <td class="d-none d-sm-table-cell">
                <router-link
                  class="btn btn-xs"
                  role="button"
                  :to="{
                    path: `pronuncia/sentenza/${p.year}/${p.number}`,
                    // query: {docUri: p.docUri},
                  }">
                  <svg class="icon">
                    <use :xlink:href="icons.itPasswordVisible"></use>
                  </svg>
                </router-link>
                <a
                  role="button"
                  aria-label="Download Akoma Ntoso"
                  class="btn btn-xs"
                  :href="getDownloadUrl(p.docUri, p.year, p.number)"
                  target="_blank">
                  <svg class="icon">
                    <use :xlink:href="icons.itDownload"></use>
                  </svg>
                </a>
              </td>
            </tr>
            <tr>
              <th
                scope="row"
                colspan="5">
                <infinite-loading
                  @infinite="infiniteHandlerSentenze"
                  :distance='1000'></infinite-loading>
              </th>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-if="!noResults.sentenze">
              <th
                scope="row"
                colspan="5">
                <Spinner />
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="tab-pane p-4 fade"
        id="tab-ordinanze"
        role="tabpanel"
        aria-labelledby="tab-ordinanze-tab">
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">Numero/Anno</th>
              <th scope="col" class="d-none d-sm-table-cell">ECLI</th>
              <th scope="col" class="d-none d-sm-table-cell">Presidente</th>
              <th scope="col">Relatore</th>
              <th scope="col" class="d-none d-sm-table-cell">Azioni</th>
            </tr>
          </thead>
          <tbody v-if="noResults.ordinanze">
            <th
                scope="row"
                colspan="5">
                <h6>Nessun Risultato per la tua ricerca! <a href="#" data-toggle="modal" data-target="#modalsearch"> Prova a corregerla!</a></h6>
              </th>
          </tbody>
          <tbody v-if="documentsList.ordinanze.length >= 1">
            <tr v-for="(pronuncia, $index) in documentsList.ordinanze"
                :key="$index"
                :set="p=pronuncia.pronunciaInfo">
              <th scope="row">
                <router-link
                  class="spacing nav-link"
                  :to="{
                    path: `pronuncia/ordinanza/${p.year}/${p.number}`,
                    // query: {docUri: p.docUri},
                  }">
                {{p.number}}/{{p.year}}
                </router-link>
              </th>
              <td class="d-none d-sm-table-cell">
                <strong class="ordinanze-text">
                  {{p.ecli}}
                </strong>
              </td>
              <td class="d-none d-sm-table-cell">{{p.presidente}}</td>
              <td>{{p.relatore}}</td>
              <td class="d-none d-sm-table-cell">
                <router-link
                  class="btn"
                  role="button btn-xs"
                  :to="{
                    path: `pronuncia/ordinanza/${p.year}/${p.number}`,
                    // query: {docUri: p.docUri},
                  }">
                  <svg class="icon">
                    <use :xlink:href="icons.itPasswordVisible"></use>
                  </svg>
                </router-link>
                <a
                  role="button"
                  aria-label="Download Akoma Ntoso"
                  class="btn btn-xs"
                  :href="getDownloadUrl(p.docUri, p.year, p.number)"
                  target="_blank">
                  <svg class="icon">
                    <use :xlink:href="icons.itDownload"></use>
                  </svg>
                </a>
              </td>
            </tr>
            <tr>
              <th
                scope="row"
                colspan="5">
                <infinite-loading
                  @infinite="infiniteHandlerOrdinanze"
                  :distance='1000'
                ></infinite-loading>
              </th>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-if="!noResults.ordinanze">
              <th
                scope="row"
                colspan="5">
                <Spinner />
              </th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import Spinner from '@/components/layout/accessory/Spinner';
import Filters from '@/components/layout/accessory/Filters';

import sprites from 'bootstrap-italia/dist/svg/sprite.svg';

Vue.use(InfiniteLoading, {
  slots: {
    spinner: Spinner,
    noMore: '',
    noResults: '',
  },
});

export default {
  name: 'DocumentsList',
  components: {
    Spinner,
    Filters,
  },
  beforeMount() {
    this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
      start: this.documentsSetsStartFromDocumentSentenze,
      size: this.documentsSetsSize,
      type: 'sentenza',
    });
    this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
      start: this.documentsSetsStartFromDocumentOrdinanze,
      size: this.documentsSetsSize,
      type: 'ordinanza',
    });
  },
  methods: {
    getDownloadUrl(docUri, year, number) {
      const separator = (process.env.NODE_ENV === 'development') ? '?' : '&';
      return `${Vue.prototype.$proxy}getDocument.xq${separator}uri=${docUri}&year=${year}&number=${number}`;
    },
    filtersSet() {
      const areFiltersSet = (
        this.pronunceFilters.years.length ||
        this.pronunceFilters.numbers.length ||
        this.pronunceFilters.ecli.length ||
        this.pronunceFilters.presidents.length ||
        this.pronunceFilters.relators.length ||
        this.pronunceFilters.judges.length
      );
      return areFiltersSet;
    },
    infiniteHandlerSentenze($state) {
      const supposedTotal =
        this.documentsSetsStartFromDocumentSentenze + (this.documentsSetsSize - 1);
      if (this.documentsList.sentenze.length ===
          supposedTotal) {
        this.documentsSetsStartFromDocumentSentenze += this.documentsSetsSize;
        this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
          start: this.documentsSetsStartFromDocumentSentenze,
          size: this.documentsSetsSize,
          type: 'sentenza',
        }).then(() => {
          if (this.documentsList.sentenze.length < this.documentsList.totalSentenze) {
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      } else {
        $state.complete();
      }
    },
    infiniteHandlerOrdinanze($state) {
      const supposedTotal = this.documentsSetsStartFromDocumentOrdinanze +
        (this.documentsSetsSize - 1);
      if (this.documentsList.ordinanze.length ===
          supposedTotal) {
        this.documentsSetsStartFromDocumentOrdinanze += this.documentsSetsSize;
        this.$store.dispatch('SAVE_DOCUMENTS_LIST', {
          start: this.documentsSetsStartFromDocumentOrdinanze,
          size: this.documentsSetsSize,
          type: 'ordinanza',
        }).then(() => {
          if (this.documentsList.ordinanze.length < this.documentsList.totalOrdinanze) {
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      } else {
        $state.complete();
      }
    },
  },
  computed: mapState(['documentsList', 'presidenti', 'relatori', 'giudici', 'pronunceFilters', 'noResults']),
  data() {
    return {
      // documentsList: [],
      documentsSetsStartFromDocumentSentenze: 1,
      sentenzeList: [],
      documentsSetsStartFromDocumentOrdinanze: 1,
      documentsSetsSize: 25,
      sortBy: 'age',
      sortDesc: false,
      icons: {
        itClose: `${sprites}#it-close`,
        itCalendar: `${sprites}#it-calendar`,
        itInfoCircle: `${sprites}#it-info-circle`,
        itArrowRight: `${sprites}#it-arrow-right`,
        itDownload: `${sprites}#it-download`,
        itPasswordVisible: `${sprites}#it-password-visible`,
      },
    };
  },
};
</script>

<style lang="less" scoped>
  .badge-total-pronunce{
    display:inline-block;
    margin-left:10px;
  }
  .affix-top{
    top:56px!important;
    background-color:white!important;
    z-index:1039!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/imports/DocumentsList.vue